import Vue from 'vue'
import Vuex from 'vuex'
import { createDirectStore } from 'direct-vuex'
import user from './modules/user'
import events from './modules/events'
import opsmonitor from './modules/opsmonitor'
import logs from './modules/logs'
import team from './modules/team/'
import assets from './modules/assets'
import videoPlayer from './modules/videoplayer'
import admin from './modules/admin'
import chatwidget from './modules/chatwidget'
import clock from './modules/clock'
import layouts from './modules/layouts'
import networkStats from './modules/networkstats'
import castTemplates from './modules/castTemplates'
import abilities from './modules/abilities'
import bots from './modules/bots'
import streams from './modules/streams'
import StoreHelper from './storehelper'
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

// Does this EVER need to be true?
const debug = false // process.env.NODE_ENV !== 'production'

export const storeDoc = {
  modules: {
    user,
    clock,
    logs,
    team,
    assets,
    videoPlayer,
    events,
    opsmonitor,
    admin,
    layouts,
    chatwidget,
    streams,
    networkStats,
    castTemplates,
    bots,
    abilities
  },
  strict: debug
} as const

const { store, rootActionContext, moduleActionContext } = createDirectStore(storeDoc)

store.commit.clock.update()
const clockInterval = setInterval(() => {
  store.commit.clock.update()
}, 60000)

const stopClockInterval = () => {
  clearInterval(clockInterval)
}

export type AppStore = typeof store

declare module 'vuex' {
  interface Store<S> {  // eslint-disable-line @typescript-eslint/no-unused-vars
    direct: AppStore
  }
}

const storehelper = new StoreHelper(store)
export { storehelper, stopClockInterval }
export { rootActionContext, moduleActionContext }
export default store
